import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';

function IncomeExpenseHeadIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state        
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new IncomeExpenseHead
    const [Name, setName] = useState('');
    const [IsExpenseOrIncome, setIsExpenseOrIncome] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [isFocused, setIsFocused] = useState(false);
    const fetchtableData = async () => {
        setLoading(true);
        fetchData('IncomeExpenseHeadApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching IncomeExpenseHeadApi:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('IncomeExpenseHeadApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);

                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('IncomeExpenseHeadApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true); // show loader

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        // ✅ Check duplicate by comparing case-insensitive
        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Income Expense Name already exists!");
            setIsLoading(false);
            return;
        }

        const IncomeExpenseHead = {
            CompanyId: companyId,
            Name,
            IsExpenseOrIncome,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('IncomeExpenseHeadApi', IncomeExpenseHead, token)
            .then((response) => {
                console.log('IncomeExpenseHead Created success:', response);
                setSuccessMessage("IncomeExpenseHead Created successfully!");
                setErrorMessage("");
                setName("");
                setIsExpenseOrIncome(false);

                setIsModalGrpOpen(false);
                window.location.reload();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('IncomeExpenseHead Create error:', error);
            })
            .finally(() => {
                setIsLoading(false); // hide loader
            });
    };

    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const openDetailModal = async (Id) => {
        try {
            const response = await fetchData('IncomeExpenseHeadApi', `/MasterDetails/${Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    // master Group model
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    const toggleModalGrp2 = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true); // start loading

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }
        try {
            await updateData('IncomeExpenseHeadApi', `${updatedData.Id}`, updatedData, token);

            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });

            window.location.reload();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false); // stop loading
        }
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', textTransform: 'uppercase' }}>Account Head</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '10px', fontSize: '14px' }}>
                            Loading...
                        </span>
                    </div>
                )}
                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>


                <Tooltip
                    title="Account Head Registration" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(to right, #041815ff, #045157ff)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        variant="contained"
                        onClick={toggleModalGroup}
                    >
                        ADD ACCOUNT HEAD
                    </Button>

                </Tooltip>
            </div>

            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                        animate-zoomIn"
                    >
                        <h6 className="text-center text-black font-bold mb-4" style={{ fontFamily: 'Times New Roman' }}>
                            ACCOUNT HEAD REGISTRATION
                        </h6>

                        {errorMessage && <p className="text-red-500 mb-2">{errorMessage}</p>}

                        <form onSubmit={addGroupRecord}>
                            <div className="flex items-end gap-4 mt-1">
                                {/* Name field (70%) */}
                                <div className="flex-1 basis-[70%]">
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">
                                        Name<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={Name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Enter Name"
                                    />
                                </div>

                                {/* Checkbox */}
                                <div className="flex items-center gap-2 mb-2">
                                    <input
                                        type="checkbox"
                                        checked={IsExpenseOrIncome}
                                        onChange={(e) => setIsExpenseOrIncome(e.target.checked)}
                                        id="IsExpenseOrIncome"
                                        className="h-4 w-4"
                                    />
                                    <label
                                        htmlFor="IsExpenseOrIncome"
                                        className="text-gray-700 text-xs font-bold"
                                    >
                                        Is Expense / Income
                                    </label>
                                </div>


                            </div>

                            <div className="flex mt-4" style={{ justifyContent: 'center' }}>
                                {/* Add Record Button */}
                                <button
                                    onClick={addGroupRecord}
                                    style={{
                                        backgroundColor: '#088b11ff',
                                        color: '#ffffff',
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        height: '32px',
                                        borderRadius: '6px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'transform 0.15s ease, background-color 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.04)';
                                        e.target.style.backgroundColor = '#1e9304ff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)';
                                        e.target.style.backgroundColor = '#09a628ff';
                                    }}
                                >
                                    {isLoading ? (
                                        <>
                                            <CircularProgress size={16} color="inherit" />
                                            Saving...
                                        </>
                                    ) : (
                                        "Add Record"
                                    )}
                                </button>

                                {/* Cancel Button */}
                                <button
                                    onClick={toggleModalGroup}
                                    style={{
                                        backgroundColor: '#64748b',
                                        color: '#ffffff',
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        height: '32px',
                                        borderRadius: '6px',
                                        border: 'none',
                                        marginLeft: '8px',
                                        cursor: 'pointer',
                                        transition: 'transform 0.15s ease, background-color 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.04)';
                                        e.target.style.backgroundColor = '#475569';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)';
                                        e.target.style.backgroundColor = '#64748b';
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>


                        </form>
                    </div>
                </div>
            )}

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70' }}>

                            <TableRow>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Sl.No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Name
                                </TableCell>

                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Expense / Income
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>

                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <TableCell sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '3px', width: '30%', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px' }}>{item.Name}</TableCell>
                                    <TableCell
                                        sx={{ padding: "3px", textAlign: "left", borderRight: "1px solid #f4dfdfff", fontSize: '11.5px' }}
                                    >
                                        {item.IsExpenseOrIncome ? "Expense" : "Income"}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>
                                        {/* {hasEditMasterPermission && ( */}
                                        <Tooltip
                                            title="Account Head Edit" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#110441ff',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => openDetailModal(item.Id)}>
                                                <EditIcon style={{ color: '#110441ff', fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {/* )}
                                        {hasDeleteMasterPermission && ( */}
                                        <Tooltip
                                            title="Account Head Delete" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#DA6C6C',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        </Tooltip>
                                        {/* )} */}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>

                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                        animate-zoomIn"
                        >
                            <h6 style={{ color: '#110441ff', textAlign: 'center', fontWeight: 'bolder', textTransform: 'uppercase', fontFamily: 'Times New Roman' }}>Account Head EDIT</h6>
                            {errorMessageEdit && <p className="text-red-500">{errorMessageEdit}</p>}
                            <div className="flex items-end gap-4 mt-1">
                                {/* Name field (70%) */}
                                <div className="flex-1 basis-[70%]">
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Name<span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        name="Name"
                                        value={updatedData.Name}
                                        onChange={handleUpdateInputChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Enter Name"
                                    />
                                </div>

                                {/* Checkbox */}
                                <div className="flex items-center gap-2 mb-2">
                                    <input
                                        type="checkbox"
                                        name="IsExpenseOrIncome"
                                        checked={updatedData.IsExpenseOrIncome || false}
                                        onChange={(e) =>
                                            handleUpdateInputChange({
                                                target: {
                                                    name: "IsExpenseOrIncome",
                                                    value: e.target.checked,
                                                },
                                            })
                                        }
                                        className="h-4 w-4"
                                    />
                                    <label
                                        htmlFor="IsExpenseOrIncome"
                                        className="text-gray-700 text-xs font-bold"
                                    >
                                        Is Expense / Income
                                    </label>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex mt-4" style={{ justifyContent: 'center' }}>
                                {/* Add Record Button */}
                                <button
                                    onClick={updateRecord}
                                    style={{
                                        backgroundColor: '#b35e15ff',
                                        color: '#ffffff',
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        height: '32px',
                                        borderRadius: '6px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'transform 0.15s ease, background-color 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.04)';
                                        e.target.style.backgroundColor = '#b06a0dff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)';
                                        e.target.style.backgroundColor = '#a66f09ff';
                                    }}
                                >
                                    {isUpdateLoading ? (
                                        <>
                                            <CircularProgress size={16} color="inherit" />
                                            Updating...
                                        </>
                                    ) : (
                                        "Update Record"
                                    )}
                                </button>

                                {/* Cancel Button */}
                                <button
                                    onClick={toggleModalGrp2}
                                    style={{
                                        backgroundColor: '#64748b',
                                        color: '#ffffff',
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        height: '32px',
                                        borderRadius: '6px',
                                        border: 'none',
                                        marginLeft: '8px',
                                        cursor: 'pointer',
                                        transition: 'transform 0.15s ease, background-color 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.04)';
                                        e.target.style.backgroundColor = '#475569';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)';
                                        e.target.style.backgroundColor = '#64748b';
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div >
    );
}

export default IncomeExpenseHeadIndex;
